<template>
  <div class="container">
    <el-form :inline="true" >
  <el-form-item label="名称">
    <el-input v-model="query.name" placeholder="名称"></el-input>
  </el-form-item>
   <el-form-item label="状态">
    <el-select v-model="query.status" placeholder="选择" clearable>
      <el-option label="正常" :value="0"></el-option>
      <el-option label="冻结" :value="2"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item>
     <el-button  type="primary" @click="getList(1)">搜索</el-button>
  </el-form-item>
   <el-form-item>
     <el-button type="primary" @click="add">新增</el-button>
  </el-form-item>
</el-form>
   
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        
        <el-tag v-if="row.status == 2" type="danger" size="small">冻结</el-tag>
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="success" @click="update(row)"
          >编辑</el-button
        >
         <el-button size="small" type="primary" @click="details(row)"
          >详情</el-button
        >
        <el-button size="small" type="success" @click="bindMec(row)"
          >旗下店铺</el-button
        >
        <el-button v-if="row.status === 0" size="small" type="danger" @click="updateStatus(row,2)"
          >冻结</el-button
        >
         <el-button v-if="row.status === 2"  size="small" type="success" @click="updateStatus(row,0)"
          >解冻</el-button
        >

      </template>
    </auto-table>
    <shopEdit @success="getList" ref="AddorEdit"></shopEdit>
  </div>
</template>

<script>
import shopEdit from '../components/coop/edit.vue';
export default {
  components: {
    shopEdit
  },
  data() {
    return {
      DataList: [],
     query:{
       name:'',
      type:'shop',
     },
      Option: [
        { name: "商户名称", value: "title" },
        { name: "联系人", value: "name" },
        { name: "联系电话", value: "phone" },
        { name: "类型", value: "type", type: "custom" },
        { name: "城市", value: "city" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      Total: 0,
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    details(row){
      this.$router.push({name:'unionCoopDetail',query:{id:row.id}});
    },
    adminDivisionHandle(row) {
      this.$refs.admindivi.visiable(row.id);
    },
    bindMec(row) {
      this.$router.push({name:'shopList',query:{coop_id:row.id,coop_name:row.title}});
    },
    add() {
      this.$refs.AddorEdit.open();
    },
    update(row) {
      this.$refs.AddorEdit.open(row);
    },
     updateStatus(row,status){
      this.$axios({
        url: "/user/cooperator/update",
        data: {
          id:row.id,
          status
        },
        method:"post"
      }).then((res) => {
       this.getList(1)
      });
    },

    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/cooperator/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          title:this.query.name || null,
           status:this.query.status,
          type:'shop'
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>